import { GalleryObject, GalleryObjectType } from "../../utils";

export const buildContents = (
  galleryObjects: Array<GalleryObject>,
  videoStartAt = 2,
  includeRemainingVideos = false,
) => {
  // Avoid traverse mutability
  const mediaImages = galleryObjects.filter(
    (go) => go.type === GalleryObjectType.IMAGE,
  );

  const mediaVideos = galleryObjects.filter(
    (go) => go.type === GalleryObjectType.VIDEO,
  );

  const content = [
    ...mediaImages.splice(0, videoStartAt),
    ...mediaVideos.splice(0, 1),
    ...mediaImages,
  ];

  includeRemainingVideos ? content.push(...mediaVideos) : "";

  return content;
};
